import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import About from "@/components/About";
import WhyChooseUs from "@/components/WhyChooseUs";
import OurNetwork from "@/components/OurNetwork";
import Showcase from "@/components/Showcase";
import BrandsMarquee from "@/components/BrandsMarquee";
import Locations from "@/components/Locations";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="relative bg-ivory text-forest-800">
      <Navbar />
      <Hero />
      <Stats />
      <About />
      <WhyChooseUs />
      <OurNetwork />
      <Showcase />
      <BrandsMarquee />
      <Locations />
      <Contact />
      <Footer />
    </main>
  );
};

export default Landing;
